import { defineMessages } from "react-intl";
const messages = defineMessages({
    back: {
        id: "app.aiDiscoverability.tutorialTooltip.back",
        defaultMessage: "Back",
    },
    next: {
        id: "app.aiDiscoverability.tutorialTooltip.next",
        defaultMessage: "Next",
    },
    stepIndicator: {
        id: "app.aiDiscoverability.tutorialTooltip.stepIndicator",
        defaultMessage: "{current}/{total}",
    },
});
export default messages;
